import React, { useContext, useEffect, useState } from "react";
import { ClientContext } from "../../../store/context";
import { keysApi } from "../../api/GardenoApi";
import { usePost } from "../../hooks/Hooks";
import { dateBoxKeys, euroSign } from "../../utils/constants";
import {
  calculateCost,
  convertToLanguage,
  dateWithoutTime,
  getImgUrl,
} from "../../utils/generalUtils";
import { Paper } from "@mui/material";
function ReservationCard() {
  const [extrasCost, setextrasCost] = useState(0);
  const {
    carToReserve,
    dropOffDate,
    dropOffTime,
    dropOffLocation,
    pickUpDate,
    pickUpTime,
    language,
    pickUpLocation,
    extrasPicked,
    insuranceChecked,
  } = useContext(ClientContext);

  const [keys, keysError] = usePost(
    keysApi.getAllKeys,
    convertToLanguage(language),
    dateBoxKeys
  );
  useEffect(() => {
    setextrasCost(0);
    extrasPicked?.forEach((extra) => {
      extra.quantity != 0 &&
        setextrasCost(
          (extrasCost) => extrasCost + extra.pricePerDay * extra.quantity
        );
    });
  }, [extrasPicked]);
  const extrasHandler = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h2>Extras</h2>
        {extrasPicked?.map(
          (extra) =>
            extra.quantity != 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <span>{`${extra?.title} (${extra?.quantity})`}</span>
                <span>
                  {String(extra.pricePerDay * extra.quantity) +
                    " " +
                    euroSign +
                    " /day"}
                </span>
              </div>
            )
        )}
      </div>
    );
  };
  return (
    <Paper
      elevation={10}
      className="reservation-page-card"
      sx={{ alignSelf: "center" }}
    >
      <span>{carToReserve?.title}</span>
      <img style={{ maxWidth: "300px" }} src={getImgUrl(carToReserve?.imgUrl)} />
      <h2>Reservation Details</h2>
      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_PICK_UP_DATE}:</span>
        <span>{pickUpDate?.format("DD-MM-YYYY")}</span>
      </div>
      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_PICKUP_UP_TIME}:</span>
        <span>{pickUpTime}</span>
      </div>

      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_PICKUP_UP_LOCATION}:</span>
        <span>{pickUpLocation}</span>
      </div>

      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_DROP_OFF_DATE}:</span>
        <span>{dropOffDate?.format("DD-MM-YYYY")}</span>
      </div>

      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_DROP_OFF_TIME}:</span>
        <span>{dropOffTime}</span>
      </div>

      <div className="row-space-btw">
        <span>{keys?.settings?.CALENDAR_DROP_OFF_LOCATION}:</span>
        <span>{dropOffLocation}</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <h2>Insurance</h2>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <span>{insuranceChecked?.title}</span>
          <span>
            {String(insuranceChecked.pricePerDay) + " " + euroSign + " /day"}
          </span>
        </div>
      </div>

      {extrasCost != 0 && extrasHandler()}
      <div className="row-space-btw">
        <h2>Total:</h2>
        <span>
          {calculateCost(
            `${pickUpDate?.format("YYYY-MM-DD")}T${pickUpTime}:00`,
            `${dropOffDate?.format("YYYY-MM-DD")}T${dropOffTime}:00`,
            carToReserve?.currentRate + extrasCost + insuranceChecked?.pricePerDay
          ) +
            " " +
            euroSign}
        </span>
      </div>
    </Paper>
  );
}

export default ReservationCard;
